import React from "react";
import PermissionRow from "../../Permissions";

export default class EditPermissionsToggles extends React.Component {
  render() {
    const {permissions, disabled, onChange} = this.props;

    return (
      <React.Fragment>
        <PermissionRow
          label="Edit Account"
          name="edit.account"
          value={permissions.edit.account}
          onChange={onChange}
          description="Allow user to edit the account plan. The user can change the selected plan, manage payment options, and manage the account status."
          disabled={disabled}
        />
        <PermissionRow
          label="Edit Resources"
          name="edit.resources"
          value={permissions.edit.resources}
          onChange={onChange}
          description="Allow user to create, edit, and remove resources. The user can create new facilities, buildings, floors, markers, and infographics. This user can only share access of newly created resources to other users with the same tags."
          disabled={disabled}
        />
        <PermissionRow
          label="Edit Users"
          name="edit.users"
          value={permissions.edit.users}
          onChange={onChange}
          description="Allow user to edit and remove current users. This permission will allow the user to edit all other users in the account, including their edit capabilities, tags, and access to resources. The user can invite new members."
          disabled={disabled}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PermissionsToggles/EditPermissions/index.jsx